import React, { useEffect, useReducer} from 'react';
import {Container, Row, Nav, Button,} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
const Footer = () => {
    



    return (
        
<div id="footerlastbox">


    <Row className="aboutfooterfirstbox mobilefooter">
        <div className="col-md-2">
        <h6 className="footermenuhead">QUICK LINKS</h6>
        <br/>
                <Nav.Link  as={Link} to="/firm" >     <p  className="footermenubody">The Firm</p></Nav.Link>
                <Nav.Link  as={Link} to="/ourpeople" >     <p   className="footermenubody">Our People</p></Nav.Link>
                {/* <Nav.Link  as={Link} to="/faq" >     <p   className="footermenubody">News</p></Nav.Link> */}

        </div>

            <div className="col-md-3">
                <h6 className="footermenuhead">EXPLORE RICH-OAK</h6>
                <br/>
                <Nav.Link  as={Link} to="/credit" >     <p  className="footermenubody">Credit</p></Nav.Link>
                <Nav.Link  as={Link} to="/investment" >     <p  className="footermenubody">Investment</p></Nav.Link>

                <Nav.Link  as={Link} to="/realestate" >     <p   className="footermenubody">Real Estate</p></Nav.Link>
      


     
     </div>

     <div className="col-md-3 footer2">
     <h6 className="footermenuhead">GET IN TOUCH</h6>
     <br/>
     <Nav.Link  as={Link} to="/career" > <p   className="footermenubody">Career</p></Nav.Link>

     
     </div>

     <div className="col-md-2 footer2">
     <h6 className="footermenuhead">LEGAL</h6>
     <br/>
     {/* <Nav.Link  as={Link} to="/signup" > <p   className="footermenubody">FAQ`s</p></Nav.Link> */}
     {/* <Nav.Link  as={Link} to="/login" >    <p   className="footermenubody">Privacy Policy</p></Nav.Link> */}
     {/* <Nav.Link  as={Link} to="/login" >    <p   className="footermenubody">T & C</p></Nav.Link> */}

     
     </div>

     <div className="col-md-2 footer3">
     <h6 className="footermenuhead">SOCIAL MEDIA</h6>
{/* <p className='footersocial'> */}
<br/>

<p className="footermenup">
{/* <a target="_blank" href="https://linkedin.com/richoakgroup"><img className='footersocialp1'  src="images/icons/linkedin.png"/></a> */}
{/* <a target="_blank" href="https://facebook.com/richoakgroup"><img className='footersocialp' src="images/icons/facebook.png"/></a> */}
<a target="_blank" href="https://instagram.com/richoakgroup"><img className='footersocialp' src="images/icons/instagram.png"/></a>
<a target="_blank" href="https://twitter.com/richoakgroup"><img className='footersocialp' src="images/icons/twitter.png"/></a>
</p>
{/* </p> */}
     <br/>
     </div>

  
    </Row>





    </div>
    )
}


export {Footer as default}